import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.ProfileModule.hooks.useTryAllFeatures', {
    trialActivationTimeoutError: 'Trial activation timeout error. Please try again.',
    somethingWentWrong: 'Oops, something went wrong',
});
